import CompanyDepartmentsSerializer from '../serializers/CompanyDepartmentsSerializer';

import * as api from '../../../../lib/api/v1/index';
import {ApiResponse, ApiResponseError} from '../../../../lib/api/v1/types';
import {forceLogout} from '../../../../services/auth-service';

export class CompanyDepartmentsService {
  async getCompanyDepartments(companyId: string): Promise<ApiResponse<any>> {
    try {
      const response = await api.getCompanyDepartments(companyId);
      const body = await response.json();

      if (response.ok) {
        const companyDepartments = CompanyDepartmentsSerializer.toObject(body);
        return {
          ok: true,
          data: companyDepartments,
          error: undefined,
        };
      }

      if (response.status === 401) {
        forceLogout();
      }
      return {
        ok: false,
        data: undefined,
        error: body as ApiResponseError,
      };
    } catch (error: any) {
      return {
        ok: false,
        data: undefined,
        error: {
          error_code: 'CLI_0000',
          error_message: 'Web client error',
          extra_details: error.message,
        },
      };
    }
  }
}
